import React from "react";
import { Container, CircularProgress, Typography, Box } from "@mui/material";

const Loader = ({ message }) => {
  const loaderMessageColor = "var(--loader-message-color, #4b5563)";
  const loaderSpinnerColor = "var(--loader-spinner-color, #1976d2)";

  return (
    <Container>
      <Box className="flex flex-col items-center justify-center py-10 space-y-4">
        <CircularProgress aria-label="Loading indicator" sx={{ color: loaderSpinnerColor }} />
        {message && (
          <Typography variant="body1" className="text-center" sx={{ color: loaderMessageColor }}>
            {message}
          </Typography>
        )}
      </Box>
    </Container>
  );
};

export default Loader;
